import { CookieDeclaration } from '@jotta/ui/CookieDeclaration'

export function CookiesRoute() {
  return <CookieDeclaration />
}
